import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import history from '../history';
import {
  AUTH_TOKEN,
  ROLE,
  USER,
  USER_LOGGED,
} from 'constants/AuthConstant';
import { notification } from 'antd';

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000,
});

// Config
const ENTRY_ROUTE = '/auth/login';
const TOKEN_PAYLOAD_KEY = 'authorization';
const PUBLIC_REQUEST_KEY = 'public-request';

// API Request interceptor
service.interceptors.request.use(
  config => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN);
    // const jwtToken = true;
    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`;
    }

    if (!jwtToken && !config.headers[PUBLIC_REQUEST_KEY]) {
      history.push(ENTRY_ROUTE);
      window.location.reload();
    }

    return config;
  },
  error => {
    // Do something with request error here
    notification.error({
      message: 'Error',
    });
    Promise.reject(error);
  }
);

const clearSessionAndRedirect = () => {
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(USER);
  localStorage.removeItem(ROLE);
  localStorage.removeItem(USER_LOGGED);
  window.location.href = ENTRY_ROUTE;
};

// API respone interceptor
service.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error?.response?.status === 401) {
      clearSessionAndRedirect();
    }
    return Promise.reject(error);
  }
);

export default service;
